import {Timestamp} from "@firebase/firestore-types";

type JSONTimestamp = {
  _seconds: number,
  _nanoseconds: number
}

export type CrosswordDataType = {
  id: string,
  title: string,
  date?: Timestamp | JSONTimestamp,

  createdAt: Timestamp | JSONTimestamp,
  createdBy: string,

  updatedAt?: Timestamp | JSONTimestamp,
  updatedBy?: string,

  grid: string,
  downAnswers: Array<string | null>,
  acrossAnswers: Array<string | null>,

  description?: string,
  author?: string,

  nextDate?: Timestamp | JSONTimestamp
}

export const crosswordDate = (date: Timestamp | JSONTimestamp | undefined): Date | null => {
  if (!date) return null
  let dateObj: Date
  if ('toDate' in date) {
    dateObj = date.toDate()
  } else {
    dateObj = new Date(date._seconds * 1000 + date._nanoseconds / 1000000)
  }
  return dateObj

}

export type CrosswordFileType = {
  grid: string,
  downAnswers: Array<string | null>,
  acrossAnswers: Array<string | null>,
  title: string,
  date?: Date | null
}